import Swipeout from './Swipeout';

export default Swipeout;



// WEBPACK FOOTER //
// ./src/index.tsx